module.exports = __webpack_public_path__ + "images/audi5e653ed2a15613c61fa085df8ec99d11.png";